<template>
  <div class="">
    <div class="zuotab" :class="xs?'xs':'yc'">
      <figure style="background-color: #FF0000;" v-if="type!='zy'">
        <figcaption v-if="!flag" style="color: #FFFFFF;font-weight: 800;font-size: 24px; margin-top: 0;">{{day}}
        </figcaption>
        <figcaption v-if="!flag" style="margin-top: 0px;color: #FFFFFF;font-size: 14px;">距高考</figcaption>
        <figcaption v-if="flag" style="color: #FFFFFF;font-weight: 800;font-size: 18px; margin-top: 0;">金榜</figcaption>
        <figcaption v-if="flag" style="color: #FFFFFF;font-weight: 800;font-size: 18px; margin-top: 0;">题名</figcaption>
      </figure>
      <!-- <figure @click="openyixuan" v-if="type=='zy'">
        <span style="font-size: 32px;">{{zynum}}</span>
        <figcaption>已选志愿</figcaption>
      </figure> -->
      <figure @click="cang" @mouseover="sc=false" @mouseleave="sc=true">
        <img src="../assets/img/shouchang.png" v-if="sc">
        <img src="../assets/img/shouchang1.png" v-else>
        <figcaption>我的收藏</figcaption>
      </figure>
      <figure @mouseover="zxrx = false" @mouseleave="zxrx =true">
        <img src="../assets/img/dianh.png" v-if="zxrx">
        <img src="../assets/img/dianh2.png" v-else>
        <figcaption>咨询热线</figcaption>
        <div class="gongzhao" v-if="!zxrx">
          <label>热线电话：</label>
          <div class="shoujids">
            {{$WebName?'400-150-6806':'18562615223'}}
          </div>
        </div>
      </figure>
      <figure @mouseover="wxzx = false" @mouseleave="wxzx = true">
        <img src="../assets/img/phone.png" v-if="wxzx">
        <img src="../assets/img/phone1.png" v-else>
        <figcaption>手机APP</figcaption>
        <div class="gongzhao" v-if="!wxzx">
          <img src="../assets/img/payewm.png" v-if="$WebName">
          <img src="../assets/img/payewm1.png" v-else>
          <span>高考志愿</span>
          <label>扫码下载APP</label>
        </div>
      </figure>
      <figure @mouseover="bzzx=false" @mouseleave="bzzx = true">
        <img src="../assets/img/erweima.png" v-if="bzzx">
        <img src="../assets/img/erweima2.png" v-else>
        <figcaption>帮助中心</figcaption>
        <div class="gongzhao" v-if="!bzzx">
          <img src="../assets/img/bzzx.png" v-if="$WebName">
          <img src="../assets/img/bzzx1.png" v-else>
          <span>帮助中心</span>
          <label>扫码查看帮助中心</label>
        </div>
      </figure>
      <figure @mouseover="gzh=false" @mouseleave="gzh = true">
        <img src="../assets/img/erweima.png" v-if="gzh">
        <img src="../assets/img/erweima2.png" v-else>
        <figcaption>公众号</figcaption>
        <div class="gongzhao" v-if="!gzh">
          <img src="../assets/img/payewm.jpg" v-if="$WebName">
          <img src="../assets/img/payewm4.png" v-else>
          <span>高考志愿</span>
          <label>扫码关注公众号</label>
        </div>
      </figure>
      <figure @click="toTop" @mouseover="shang=false" @mouseleave="shang = true">
        <img src="../assets/img/shang.png" v-if="shang">
        <img src="../assets/img/shang1.png" v-else>
        <figcaption>返回顶部</figcaption>
      </figure>

    </div>
    <div class="zuotab sq" @click="xs=!xs">
      {{xs?"隐藏":"显示"}}
    </div>
  </div>
</template>

<script>
  export default {
    name: "",
    components: {

    },
    props: ['type'],
    data() {
      return {
        gzh: true,
        wxzx: true,
        zxrx: true,
        bzzx:true,
        sc: true,
        shang: true,
        zynum: 0,
        day: 0,
        flag: false,
        xs:true
      }
    },
    mounted() {
      if (this.type == 'zy') {
        this.zhiyuannum()
      }
      let now = new Date();
       // now = new Date("2022-06-09 00:00:00");
      let year = now.getFullYear(); //年
      let month = now.getMonth() + 1; //月
      let day = now.getDate(); //日
      let time1 = new Date(year + "-06-07 00:00:00").getTime();
      let time2 = new Date(year + "-06-09 00:00:00").getTime();
      let time3 = new Date(year + "-09-01 00:00:00").getTime();
      if (now.getTime() < time1) {
        this.day = Math.ceil((time1 - now.getTime()) / (24 * 60 * 60 * 1000))
      } else {
        time1 = new Date((year + 1) + "-06-07 00:00:00").getTime();
        this.day = Math.ceil((time1 - now.getTime()) / (24 * 60 * 60 * 1000))
      }
      if ((month == 6 && (day == 7 || day == 8))||(now.getTime() >= time2&&now.getTime() < time3)) {
        this.flag = true
      } else {
        this.flag = false
      }
    },
    methods: {
      zhiyuannum() {
        let list = [];
        let cyc = this.$utils.getlocalStorage("ZhiYuancyc");
        let wyw = this.$utils.getlocalStorage("ZhiYuanwyw");
        let byb = this.$utils.getlocalStorage("ZhiYuanbyb");
        let dyd = this.$utils.getlocalStorage("ZhiYuandyd");
        list = list.concat(cyc.ids)
        list = list.concat(wyw.ids)
        list = list.concat(byb.ids)
        list = list.concat(dyd.ids)
        this.zynum = list.length;
      },
      openyixuan() {
        this.$emit("openyixuan", {
          flag: true
        })
      },
      cang() {
        if (this.$utils.tologin(this)) {
          this.$router.push('/grzx_shouchangxueyuan')
        }
      },
      toTop() {
        let top = document.documentElement.scrollTop || document.body.scrollTop;
        // 实现滚动效果
        const timeTop = setInterval(() => {
          document.body.scrollTop = document.documentElement.scrollTop = top -= 100;
          if (top <= 0) {
            clearInterval(timeTop);
          }
        }, 10);
      },
    }
  }
</script>

<style scoped>
  .gongzhao {
    position: absolute;
    right: 80px;
    top: 0;
    width: auto;
    height: auto;
    padding: 5px;
    box-sizing: border-box;
    background: rgba(255, 252, 252, 1);
    border: 1px solid #FF0000;
    opacity: 1;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .gongzhao img {
    width: 120px !important;
    height: 120px !important;
    margin-bottom: 5px;
  }

  .gongzhao span {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #F53824;
    margin-bottom: 5px;
  }

  .gongzhao label {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .shoujids {
    font-size: 16px;
    width: 120px;
    text-align: center;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
    white-space: nowrap;
  }

  .zuotab figure:nth-of-type(2) {
    position: relative;
  }

  .zuotab figure:nth-of-type(3) {
    position: relative;
  }

  .zuotab figure:nth-of-type(4) {
    position: relative;
  }

  .zuotab figure:nth-of-type(5) {
    position: relative;
  }

  .zuotab figure:nth-of-type(6) {
    position: relative;
  }
  .zuotab figure:nth-of-type(7) {
    position: relative;
  }
.zuotab figure:nth-of-type(1):hover {
    background: #F53824;
  }
  .zuotab figure:nth-of-type(2):hover {
    background: #F53824;
  }

  .zuotab figure:nth-of-type(3):hover {
    background: #F53824;
  }

  .zuotab figure:nth-of-type(4):hover {
    background: #F53824;
  }

  .zuotab figure:nth-of-type(5):hover {
    background: #F53824;
  }

  .zuotab figure:nth-of-type(6):hover {
    background: #F53824;
  }
  .zuotab figure:nth-of-type(7):hover {
    background: #F53824;
  }
.zuotab figure:nth-of-type(1):hover figcaption {
    color: #FFFFFF;
  }
  .zuotab figure:nth-of-type(2):hover figcaption {
    color: #FFFFFF;
  }

  .zuotab figure:nth-of-type(3):hover figcaption {
    color: #FFFFFF;
  }

  .zuotab figure:nth-of-type(4):hover figcaption {
    color: #FFFFFF;
  }

  .zuotab figure:nth-of-type(5):hover figcaption {
    color: #FFFFFF;
  }

  .zuotab figure:nth-of-type(6):hover figcaption {
    color: #FFFFFF;
  }
  .zuotab figure:nth-of-type(7):hover figcaption {
    color: #FFFFFF;
  }

  /* 右边固定 */
  .zuotab {
    height: auto;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 55%;
    /* right: 0px; */
    transform: translate(-50%, -50%);
  }
  .sq{
    width: 14px;
    right: 0;
    color: #F53824;
  }
  .yc{
    /* right: -100px; */
    animation: my-animation 1s ease 0s forwards;
  }
  .xs{
    animation: my-animation1 1s ease 0s forwards;
  }
  @keyframes my-animation {
    0% { right: 0; }
    100% { right: -100px; }
  }
  @keyframes my-animation1 {
    0% { right: -100px; }
    100% { right: 0; }
  }

  .zuotab figure {
    cursor: pointer;
    background-color: #FFFFFF;
    margin: 4px 0;
    width: 64px;
    height: 62px;
    border: 1px solid #FF0000;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .zuotab figure span {
    line-height: 28px;

    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824;
    opacity: 1;
  }

  .zuotab figure img {
    width: 20px;
    height: 20px;
  }

  .zuotab figure figcaption {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/zuoxuanfu1.vue